import React from 'react';
import SaleIcon from '@tradera/blueprint/theme/icons2/sale.svg?jsx';
import SizeIcon from '@tradera/blueprint/theme/icons2/size.svg?jsx';
import ColorIcon from '@tradera/blueprint/theme/icons2/color.svg?jsx';
import GenderIcon from '@tradera/blueprint/theme/icons2/gender.svg?jsx';
import PatternIcon from '@tradera/blueprint/theme/icons2/pattern.svg?jsx';
import ShapeIcon from '@tradera/blueprint/theme/icons2/shape.svg?jsx';

export const getAttributeIcon = (attribute, props) => (
    <AttributeIcon {...props} attribute={attribute} />
);

const AttributeIcon = ({ attribute, className, ...otherProps }) => {
    switch (attribute) {
        case 'af-clothes_size':
        case 'af-shoe_size':
            return (
                <SizeIcon
                    className={`icon mirror-x ${className}`}
                    {...otherProps}
                />
            );
        case 'af-color':
        case 'random_color':
            return (
                <ColorIcon className={`icon ${className}`} {...otherProps} />
            );
        case 'af-shoe_model':
            return (
                <ShapeIcon className={`icon ${className}`} {...otherProps} />
            );
        case 'random_gender':
            return (
                <GenderIcon className={`icon ${className}`} {...otherProps} />
            );
        case 'af-pattern':
            return (
                <PatternIcon className={`icon ${className}`} {...otherProps} />
            );
        case 'brand':
        default:
            return (
                <SaleIcon
                    className={`icon mirror-x ${className}`}
                    {...otherProps}
                />
            );
    }
};
